<template src='./project-document-revisions.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { getAccessToken } from '@/utils/cookie'
import FileSaver from 'file-saver'
import { authorizedOrganizationId, hasDMSManageClaim } from '@/router/auth'
import { EventBus } from '@/router/bus'
import ProjectDocumentUpload from '../file-upload/ProjectDocumentUpload'

export default {
  components: {
    ContextPage,
    'project-document-upload': ProjectDocumentUpload
  },
  data () {
    return {
      data: [],
      projectCode: this.$route.params.projectCode,
      revisionId: this.$route.params.revisionId,
      projectDocumentApi: Vue.$config.api_root + '/' + Vue.$apiConfig.projectDocumentPost.replace('{projectCode}', this.$route.params.projectCode),
      projectDocumentHeaders: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      sizeLimit: 1024 * 1024 * 10,
      filesLimit: 5,
      ProjectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      project: {},
      files: [],
      description: '',
      comment: '',
      expandDownloads: false,
      revisions: [],
      singleRevision: {},
      deleteDialog: false,
      secureLinkDialog: false,
      disableButton: false,
      copyLinkSnackbar: false,
      selectedDocument: '',
      documentsKey: 0,
      addRevisionLabel: this.$t('projects.document.revisionAdd'),
      secureLink: {
        secured: this.$t('projects.document.secured'),
        securedDesc: this.$t('projects.document.securedDescription'),
        public: this.$t('projects.document.public'),
        publicDesc: this.$t('projects.document.publicDescription')
      }
    }
  },
  computed: {
    canManageDocuments () {
      return hasDMSManageClaim() && this.project.organizationId === authorizedOrganizationId() && this.project.status === this.ProjectStatus.PENDING
    }
  },
  created () {
    EventBus.$on('uploadedDocument', (jsonScheme) => {
      this.handleUploaded()
    })
    this.showRevisions(true)
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    download (id, title) {
      this.showLoader(true)
      this.disableButton = true
      this.$http.get(Vue.$apiConfig.projectDocumentGet.replace('{projectCode}', this.$route.params.projectCode) + '/' + id, { responseType: 'arraybuffer' })
        .then(
          response => {
            var headers = response.headers
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, title)
            this.showRevisions()
            this.showLoader(false)
            this.disableButton = false
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.disableButton = false
          }
        )
    },
    showRevisions (initial) {
      if (!this.$route.params.documentId) return
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.projectDocumentRevisionGet.replace('{projectCode}', this.$route.params.projectCode).replace('{documentId}', this.$route.params.documentId))
        .then(
          response => {
            this.revisions = response.data.payload
            if (initial) {
              this.downloadAutomatically()
            }
            this.project = response.body.additionalInformation.project
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    handleErrors (newFile) {
      if (newFile.xhr) {
        console.log(newFile)
        this.formatDocumentErrorResponse(newFile.xhr)
      }
      this.showLoader(false)
    },
    expandDownloadsDialog (revision) {
      this.revisionId = revision.id
      this.$set(revision, 'expandDownloads', !revision.expandDownloads)
    },
    downloadRevision (revision) {
      this.download(revision.id, revision.title)
    },
    downloadAutomatically () {
      if (this.$route.query.automaticDownload === 'true' && this.revisionId) {
        var revision = this.revisions.find(x => x.id === Number(this.revisionId))
        this.download(revision.id, revision.title)
      }
    },
    openLinkDialog (revision) {
      this.secureLinkDialog = true
      this.singleRevision = {
        title: revision.title,
        documentId: revision.documentId,
        revision: revision.revision,
        secureLink: revision.secureLink,
        url: location.origin + '/document-download?token=' + revision.name + revision.revision
      }
    },
    updateRevisionSecurity () {
      this.showLoader(true)
      this.disableButton = true
      this.$http.put(Vue.$apiConfig.projectDocumentRevisionSecurityUpdate.replace('{projectCode}', this.$route.params.projectCode).replace('{documentId}', this.singleRevision.documentId).replace('{revision}', this.singleRevision.revision).replace('{secureLink}', this.singleRevision.secureLink))
        .then(
          response => {
            this.showLoader(false)
            this.disableButton = false
            this.secureLinkDialog = false
            var revision = this.revisions.find(x => x.revision === this.singleRevision.revision)
            revision.secureLink = this.singleRevision.secureLink
            this.singleRevision = {}
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.disableButton = false
          }
        )
    },
    copyLink (revision) {
      const element = document.querySelector('#link')
      element.select()
      element.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.selectedDocument = revision.title
      this.copyLinkSnackbar = true
    },
    showDeletePromptDialog (revision) {
      this.deleteDialog = true
      this.revisionId = revision.id
    },
    deleteRevision () {
      this.showLoader(true)
      this.disableButton = true
      this.$http.delete(Vue.$apiConfig.projectDocumentDelete.replace('{projectCode}', this.$route.params.projectCode) + '/' + this.revisionId)
        .then(
          response => {
            this.showLoader(false)
            this.disableButton = false
            this.revisionId = 0
            this.deleteDialog = false
            if (response.data.payload.revisionsCount > 1) {
              this.showRevisions(this.$route.params.documentId)
            } else {
              this.backToDocuments()
            }
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.disableButton = false
          }
        )
    },
    handleUploaded () {
      this.showRevisions(this.$route.params.documentId)
      this.showLoader(false)
    },
    backToDocuments () {
      this.$router.push({ name: 'singleProjectdocuments' })
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}

.label-container {
  display: inline-flex;
  justify-content: flex-start;
  align-items: start;
}

.label-text {
  display: flex;
  justify-items: center;
  align-items: center;
  height: 100%;
}

.prefix {
  font-weight: bold;
}

.text-spacing {
  padding-inline-start: 8px;
  padding-inline-end: 4px;
}
</style>
